module.exports = __webpack_public_path__ + "static/media/icon-replace.79c6bb57.svg";